import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-shrink-0 flex-col mb-8" }
const _hoisted_2 = { class: "text-sm font-medium mx-2" }
const _hoisted_3 = { class: "text-xs text-gray-400" }
const _hoisted_4 = { class: "px-1 pt-1 max-w-xs flex flex-col rounded-md bg-gray-100" }
const _hoisted_5 = { class: "w-full py-3 px-1 flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "mb-1 text-sm font-bold"
}
const _hoisted_7 = { class: "text-xs text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-gray-500 font-medium" }, "この画像は削除されています", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "送信された動画を表示", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mr-1"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "送信された音声を表示", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mr-1"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "送信されたファイルを表示", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mr-1"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" })
], -1)
const _hoisted_15 = { class: "flex justify-end" }
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 text-white",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" }),
  /*#__PURE__*/_createVNode("path", { d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex items-center mb-2", _ctx.dynamicMetaCss]
    }, [
      _createVNode("img", {
        src: _ctx.icon,
        alt: "Icon",
        class: "w-8 h-8 rounded-full"
      }, null, 8, ["src"]),
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.item.data.from.name), 1),
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.timeText), 1)
    ], 2),
    (_ctx.templateMessage)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["flex justify-end", _ctx.dynamicContentCss]
        }, [
          _createVNode("div", _hoisted_4, [
            (_ctx.templateMessage.thumbnailUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.templateMessage.thumbnailUrl,
                  alt: "thumbnail",
                  class: "object-cover"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_5, [
              (_ctx.templateMessage.title)
                ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.templateMessage.title), 1))
                : _createCommentVNode("", true),
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.item.data.messageText), 1)
            ])
          ])
        ], 2))
      : (_ctx.imageSrc && _ctx.isImageAvailable)
        ? (_openBlock(), _createBlock("img", {
            key: 1,
            src: _ctx.imageSrc,
            alt: "Content Image",
            class: ["object-contain", _ctx.dynamicContentCss]
          }, null, 10, ["src"]))
        : (_ctx.imageSrc && !_ctx.isImageAvailable)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: ["object-contain p-3 rounded-md bg-gray-100 text-sm font-normal text-yellow-300 flex", _ctx.dynamicContentCss]
            }, [
              _createVNode(_component_m_icon, {
                type: "warning",
                size: "6",
                class: "mr-2"
              }),
              _hoisted_8
            ], 2))
          : (_ctx.videoSrc)
            ? (_openBlock(), _createBlock("a", {
                key: 3,
                href: _ctx.videoSrc,
                target: "_blank",
                rel: "noopener noreferrer",
                class: ["flex items-center justify-between p-4 bg-gray-100 text-sm text-primary-500 rounded cursor-pointer", _ctx.dynamicContentCss]
              }, [
                _hoisted_9,
                _hoisted_10
              ], 10, ["href"]))
            : (_ctx.audioSrc)
              ? (_openBlock(), _createBlock("a", {
                  key: 4,
                  href: _ctx.audioSrc,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: ["flex items-center justify-between p-4 bg-gray-100 text-sm text-primary-500 rounded cursor-pointer", _ctx.dynamicContentCss]
                }, [
                  _hoisted_11,
                  _hoisted_12
                ], 10, ["href"]))
              : (_ctx.fileSrc)
                ? (_openBlock(), _createBlock("a", {
                    key: 5,
                    href: _ctx.fileSrc,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: ["flex items-center justify-between p-4 bg-gray-100 text-sm text-primary-500 rounded cursor-pointer", _ctx.dynamicContentCss]
                  }, [
                    _hoisted_13,
                    _hoisted_14
                  ], 10, ["href"]))
                : (_openBlock(), _createBlock("div", {
                    key: 6,
                    class: ["p-4 bg-gray-100 text-sm rounded whitespace-pre-wrap break-words", _ctx.dynamicContentCss],
                    onContextmenu: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.emitDeleteEvent($event, _ctx.item)), ["right"]))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.item.data.messageText) + " ", 1),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("button", {
                        class: "rounded-bl-lg rounded-tl-lg shadow-lg text-white px-3 py-1.5 mt-4 focus:outline-none  bg-secondary-500 truncate",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.askChatGPT(_ctx.item.data.messageText ?? '')))
                      }, " AI返信：" + _toDisplayString(_ctx.chatGPTMode), 1),
                      _createVNode("button", {
                        class: "ml-0.5 rounded-tr-lg rounded-br-lg shadow-lg text-white px-3 py-1.5 mt-4 focus:outline-none  bg-secondary-500",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChatGPTConfig()))
                      }, [
                        _hoisted_16
                      ])
                    ])
                  ], 34))
  ]))
}